function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useRef } from "react";
import { useParallax } from "helpful-motion-hooks";
import { motion, useTransform } from "framer-motion";
import { twMerge } from "../../../utils";
import { useRandom } from "../../../hooks";
var linesArray = new Array(4).fill(null).map(function(_, index) {
    return "line-".concat(index);
});
export function SectionLines(param) {
    var lines = param.lines, className = param.className;
    var ref = useRef(null);
    var ref1 = _slicedToArray(useParallax(ref), 2), ty = ref1[0], invty = ref1[1];
    var showLeftLine = useRandom(function(num) {
        return Math.round(num);
    });
    var showRightLine = useRandom(function(num) {
        return Math.round(num);
    });
    var leftLinePositionTop = useRandom(function(num) {
        return Math.round(num * 70) + 15;
    });
    var rightLinePositionTop = useRandom(function(num) {
        return Math.round(num * 70) + 15;
    });
    var leftLineHeight = leftLinePositionTop !== null ? leftLinePositionTop > 50 ? "h-8" : "h-11" : null;
    var rightLineHeight = rightLinePositionTop !== null ? rightLinePositionTop > 50 ? "h-8" : "h-11" : null;
    var relativety = useTransform(ty, function(value) {
        return value * 100;
    });
    var relativeinvty = useTransform(invty, function(value) {
        return value * 100;
    });
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        role: "presentation",
        className: twMerge("flex justify-between pointer-events-none -mx-4 md:-mx-5", className)
    }, linesArray.map(function(id, index) {
        return /*#__PURE__*/ React.createElement("span", {
            key: id,
            className: twMerge("isolate border-r border-dashed w-0 last-of-type:hidden first-of-type:hidden md:first-of-type:block md:last-of-type:block", lines === "light" && "border-fg-inverted/10", lines === "dark" && "border-fg-default/10")
        }, (index === 0 || index === linesArray.length - 1) && /*#__PURE__*/ React.createElement(motion.span, {
            role: "presentation",
            className: twMerge("block relative border-r w-0 opacity-0 transition-opacity duration-1000", lines === "light" && "border-bg-default", lines === "dark" && "border-bg-inverted", index === 0 && leftLineHeight, index === linesArray.length - 1 && rightLineHeight, index === 0 && showLeftLine && "opacity-0 md:opacity-100", index === linesArray.length - 1 && showRightLine && "opacity-0 md:opacity-100"),
            style: _objectSpreadProps(_objectSpread({}, index === 0 ? {
                top: "".concat(leftLinePositionTop, "%")
            } : {}, index === linesArray.length - 1 ? {
                top: "".concat(rightLinePositionTop, "%")
            } : {}), {
                y: index === 0 ? relativety : relativeinvty
            })
        }));
    }));
}

//# sourceMappingURL=SectionLines.js.map